module.exports = __webpack_public_path__ + "img/monarch-ui-icon_CELL_LINE.81a6ad77.png";